import { Flex, Button, toast } from "@jsq/ds/core";
import { client } from "~/apollo/client";
import { useReopenCaseMutation } from "~/graphql/supergraphHooks";
import { SPACING } from "~/styles/variables";

interface Props {
  caseId: number;
}

const ClosedControls = ({ caseId }: Props) => {
  const [reopenCaseMutation, { loading }] = useReopenCaseMutation({
    refetchQueries: ["GetComplianceCase", "GetComplianceCaseAuditLogs"],
    onCompleted: async () => {
      toast.success("Case reopened");
      await client.refetchQueries({
        include: "active",
      });
    },
    onError: (e) => toast.error(e.message),
  });
  const reopenCase = async () => {
    await reopenCaseMutation({
      variables: { caseId: caseId },
    });
  };

  return (
    <Flex
      style={{ margin: `${SPACING.X_SMALL} ${SPACING.LARGE}` }}
      justifyContent="space-between"
    >
      <Button
        css={{ margin: `${SPACING.X_SMALL} ${SPACING.SMALL}` }}
        isInline
        variant="neutral"
        disabled={loading}
        onClick={() => void reopenCase()}
      >
        Reopen case
      </Button>
    </Flex>
  );
};

export default ClosedControls;
